import {DashboardType} from "../../../model/dashboard/types";
import {DashboardConfig} from "../../../model/dashboard/dashboard-config";
import {WidgetType} from "../../../model/widget/widget-type";
import {CounterType} from "../../../widgets/constants/types";
import {generateUniqueId} from "../../../../../gd/utils/misc/generate-unique-id";

export function projectsOverviewConfig(projectIds:ID[]) {

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.CUSTOM,
        "widgets"   : []
    }

    _.map(projectIds, (projectId: ID, key:number)=>{
        dashboardConfig.widgets = dashboardConfig.widgets.concat(createWidgets(projectId, key) as any[])
    })

    return dashboardConfig
}


function createWidgets(projectId:ID, row:number) {

    const project = gd.session.projects.get(projectId)

    // double it's value
    row = row * 3

    if (!project) {
        console.log("no project ", projectId, "found")
        return []
    }

    return [
        {
            // "cardLayout": "none",
            "settings": {
                "includeSubFolders": true,
                "showPercents": false,
                "counterType": "tasks-total",
                "showClosedTasks": false,
                "projectIds": [
                    projectId
                ],
                "groupBy": "assignedToUserId"
            },
            "color": 6,
            "conditions": null,
            "title": "Tasks by Assignee",
            "gridPosition": {
                "y": row,
                "h": 2,
                "w": 3,
                "x": 4
            },
            "type": "tasks-summary",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "projectId": projectId,
                "displayPropertiesFieldsIds": [
                    "statusId",
                    "priority",
                    "statusComments",
                    "health",
                    "startEnd",
                    "progress"
                ]
            },
            "color": 6,
            "conditions": null,
            "title": "",
            "gridPosition": {
                "y": row,
                "h": 2,
                "w": 4,
                "x": 0
            },
            "type": WidgetType.PROFILE_PROJECT,
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "showLegend": true,
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "donut",
                "counterType": "tasks-total",
                "showClosedTasks": true,
                "projectIds": [
                    projectId
                ],
                "groupBy": "statusId"
            },
            "color": 6,
            "conditions": null,
            "title": "Tasks by Status",
            "gridPosition": {
                "y": row,
                "h": 2,
                "w": 5,
                "x": 7
            },
            "type": "task-chart",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "reportDate": {
                    "lastDays": 30
                },
                "projectIds": [
                    projectId
                ],
                "tasksStatus": "open",
                "counterType": CounterType.TASKS_TOTAL
            },
            "color": 6,
            "conditions": null,
            "title": "Open Tasks",
            "gridPosition": {
                "y": row + 2,
                "h": 1,
                "w": 7,
                "x": 0
            },
            "type": WidgetType.LINE_CHART,
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "projectIds": [
                    projectId
                ],
                "userIds": [],
                "includeSubFolders": true,
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "color": 6,
            "conditions": null,
            "title": "Time reports",
            "gridPosition": {
                "y": row+2,
                "h": 1,
                "w": 5,
                "x": 7
            },
            "type": "time-reported-by-day",
            "id": generateUniqueId()
        },

    ]
}